module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "contact-page"
  }, [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "top-image"
  }), _vm._v(" "), _c('div', {
    staticClass: "content",
    on: {
      "click": function($event) {
        _vm.dropDownOpen = false
      }
    }
  }, [_c('div', {
    staticClass: "contact-inner"
  }, [_c('div', {
    staticClass: "contactinfo"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon.svg")
    }
  }), _vm._v(" "), _vm._m(1), _vm._v(" "), _vm._m(2), _vm._v(" "), _vm._m(3), _vm._v(" "), _c('p', [_c('strong', [_vm._v("Email")]), _c('br'), _vm._v(" "), _c('A', {
    attrs: {
      "href": "mailto:office@productionlocations.com"
    }
  }, [_vm._v("office@productionlocations.com")])], 1)]), _vm._v(" "), _c('div', {
    staticClass: "contactform"
  }, [(!_vm.formSubmitted) ? [_c('p', {
    staticStyle: {
      "margin-bottom": "0"
    }
  }, [_vm._v("I'd like to…")]), _vm._v(" "), _c('div', {
    staticClass: "dropdown"
  }, [_c('div', {
    staticClass: "selected",
    class: {
      greyed: _vm.dropDownOpen
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.dropDownOpen = !_vm.dropDownOpen
      }
    }
  }, [_vm._v(_vm._s(_vm.selectedForm) + " "), _c('i', {
    staticClass: "material-icons"
  }, [_vm._v("expand_more")])]), _vm._v(" "), (_vm.dropDownOpen) ? _c('ul', {
    staticClass: "menu"
  }, [_c('li', {
    on: {
      "click": function($event) {
        _vm.selectedForm = 'Book a Property', _vm.dropDownOpen = false
      }
    }
  }, [_vm._v("Book a Property")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectedForm = 'Ask a General Question', _vm.dropDownOpen = false
      }
    }
  }, [_vm._v("Ask a General Question")]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        _vm.selectedForm = 'List My Property for Filming', _vm.dropDownOpen = false
      }
    }
  }, [_vm._v("List My Property for Filming")])]) : _vm._e()]), _vm._v(" "), (_vm.selectedForm == 'Book a Property') ? _c('div', {
    staticClass: "scout-form"
  }, [_c('p', [_vm._v("Contact one of our scouts to book a location or get help with your search.")]), _vm._v(" "), _c('form', {
    ref: "scoutform",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit('scoutform')
      }
    }
  }, [_vm._m(4), _vm._v(" "), _vm._m(5), _vm._v(" "), _c('div', {
    ref: "recaptcha",
    staticClass: "recaptcha"
  }), _vm._v(" "), (!_vm.formLoading) ? _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")]) : _c('button', {
    attrs: {
      "type": "submit",
      "disabled": "disabled"
    }
  }, [_vm._v("Sending..")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedForm == 'Ask a General Question') ? _c('div', {
    staticClass: "general-form"
  }, [_c('p', [_vm._v("Fill out the form below and someone from our office will get back to you.")]), _vm._v(" "), _c('form', {
    ref: "generalform",
    on: {
      "submit": function($event) {
        $event.preventDefault();
        _vm.formSubmit('generalform')
      }
    }
  }, [_vm._m(6), _vm._v(" "), _vm._m(7), _vm._v(" "), _c('label', {
    attrs: {
      "for": "message"
    }
  }, [_vm._v("\n                Message\n                ")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "message",
      "placeholder": "Enter your message here",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    ref: "recaptcha",
    staticClass: "recaptcha"
  }), _vm._v(" "), (!_vm.formLoading) ? _c('button', {
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("Submit")]) : _c('button', {
    attrs: {
      "type": "submit",
      "disabled": "disabled"
    }
  }, [_vm._v("Sending..")])])]) : _vm._e(), _vm._v(" "), (_vm.selectedForm == 'List My Property for Filming') ? _c('div', {
    staticClass: "list-form"
  }, [_c('p', [_vm._v("To list your property fill out our "), _c('router-link', {
    attrs: {
      "to": '/submitproperty'
    }
  }, [_vm._v("property submission form")]), _vm._v(".")], 1), _vm._v(" "), _c('p', [_vm._v("If you have a question about your submission or any other questions please use our "), _c('a', {
    on: {
      "click": function($event) {
        _vm.selectedForm = 'Ask a General Question'
      }
    }
  }, [_vm._v("contact form")]), _vm._v(".")])]) : _vm._e()] : [_c('h1', {
    staticClass: "received"
  }, [_vm._v("Submission Received")]), _vm._v(" "), _c('p', [_vm._v("Thank you! We'll get back to you as soon as possible.")])]], 2)]), _vm._v(" "), _c('div', {
    staticClass: "bottom-section"
  })])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "page-header"
  }, [_c('h1', [_vm._v("Contact Us")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Corporate Mailing Address")]), _c('br'), _vm._v("\n            Production Locations, Inc"), _c('br'), _vm._v("\n            9663 Santa Monica Blvd. #490"), _c('br'), _vm._v("\n            Beverly Hills, CA 90210\n         ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Downtown Office")]), _c('br'), _vm._v("\n            756 S Broadway #1110"), _c('br'), _vm._v("\n            Los Angeles, CA 90014\n         ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Call Us")]), _c('br'), _vm._v("\n            323.874.0404\n         ")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-left"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "firstname",
      "placeholder": "First Name",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "lastname",
      "placeholder": "Last Name",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": "Phone",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "mobile"
    }
  }, [_vm._v("Mobile Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "mobile",
      "placeholder": "Mobile"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "address"
    }
  }, [_vm._v("Address")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "address",
      "placeholder": "Address"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "city"
    }
  }, [_vm._v("City")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "city",
      "placeholder": "City"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "state"
    }
  }, [_vm._v("State")]), _vm._v(" "), _c('select', {
    attrs: {
      "name": "state",
      "required": ""
    }
  }, [_c('option', {
    attrs: {
      "value": "",
      "disabled": "",
      "selected": "",
      "hidden": ""
    }
  }, [_vm._v("Select a State")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AL"
    }
  }, [_vm._v("Alabama")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AK"
    }
  }, [_vm._v("Alaska")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AZ"
    }
  }, [_vm._v("Arizona")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "AR"
    }
  }, [_vm._v("Arkansas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CA"
    }
  }, [_vm._v("California")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CO"
    }
  }, [_vm._v("Colorado")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "CT"
    }
  }, [_vm._v("Connecticut")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DE"
    }
  }, [_vm._v("Delaware")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "DC"
    }
  }, [_vm._v("District Of Columbia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "FL"
    }
  }, [_vm._v("Florida")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "GA"
    }
  }, [_vm._v("Georgia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "HI"
    }
  }, [_vm._v("Hawaii")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ID"
    }
  }, [_vm._v("Idaho")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IL"
    }
  }, [_vm._v("Illinois")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IN"
    }
  }, [_vm._v("Indiana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "IA"
    }
  }, [_vm._v("Iowa")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KS"
    }
  }, [_vm._v("Kansas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "KY"
    }
  }, [_vm._v("Kentucky")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "LA"
    }
  }, [_vm._v("Louisiana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ME"
    }
  }, [_vm._v("Maine")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MD"
    }
  }, [_vm._v("Maryland")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MA"
    }
  }, [_vm._v("Massachusetts")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MI"
    }
  }, [_vm._v("Michigan")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MN"
    }
  }, [_vm._v("Minnesota")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MS"
    }
  }, [_vm._v("Mississippi")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MO"
    }
  }, [_vm._v("Missouri")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "MT"
    }
  }, [_vm._v("Montana")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NE"
    }
  }, [_vm._v("Nebraska")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NV"
    }
  }, [_vm._v("Nevada")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NH"
    }
  }, [_vm._v("New Hampshire")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NJ"
    }
  }, [_vm._v("New Jersey")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NM"
    }
  }, [_vm._v("New Mexico")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NY"
    }
  }, [_vm._v("New York")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "NC"
    }
  }, [_vm._v("North Carolina")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "ND"
    }
  }, [_vm._v("North Dakota")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OH"
    }
  }, [_vm._v("Ohio")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OK"
    }
  }, [_vm._v("Oklahoma")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "OR"
    }
  }, [_vm._v("Oregon")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "PA"
    }
  }, [_vm._v("Pennsylvania")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "RI"
    }
  }, [_vm._v("Rhode Island")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SC"
    }
  }, [_vm._v("South Carolina")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "SD"
    }
  }, [_vm._v("South Dakota")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TN"
    }
  }, [_vm._v("Tennessee")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "TX"
    }
  }, [_vm._v("Texas")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "UT"
    }
  }, [_vm._v("Utah")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VT"
    }
  }, [_vm._v("Vermont")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "VA"
    }
  }, [_vm._v("Virginia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WA"
    }
  }, [_vm._v("Washington")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WV"
    }
  }, [_vm._v("West Virginia")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WI"
    }
  }, [_vm._v("Wisconsin")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "WY"
    }
  }, [_vm._v("Wyoming")])]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "zip"
    }
  }, [_vm._v("Zip")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "zip",
      "placeholder": "Zip"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-right"
  }, [_c('label', {
    attrs: {
      "for": "workingtitle"
    }
  }, [_vm._v("Working Title")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "workingtitle",
      "placeholder": "Working Title"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "company"
    }
  }, [_vm._v("Company")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "company",
      "placeholder": "Company",
      "required": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "sidebyside"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "datefrom"
    }
  }, [_vm._v("Start Date")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "date",
      "name": "datefrom",
      "placeholder": "From"
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "dateto"
    }
  }, [_vm._v("End Date")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "date",
      "name": "dateto",
      "placeholder": "To"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebyside"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "daysshooting"
    }
  }, [_vm._v("Days Shooting")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "name": "daysshooting",
      "placeholder": "Days Shooting"
    }
  })]), _vm._v(" "), _c('div', [_c('label', {
    attrs: {
      "for": "daysshooting"
    }
  }, [_vm._v("Days Prep")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "name": "daysprep",
      "placeholder": "Days Prep"
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "sidebyside"
  }, [_c('div', [_c('label', {
    attrs: {
      "for": "daysshooting"
    }
  }, [_vm._v("Days Strike")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "number",
      "name": "daysstrike",
      "placeholder": "Days Strike"
    }
  })]), _vm._v(" "), _c('div')]), _vm._v(" "), _c('label', {
    attrs: {
      "for": "requestedlocation"
    }
  }, [_vm._v("Requested Location")]), _vm._v(" "), _c('textarea', {
    attrs: {
      "name": "requestedlocation",
      "placeholder": "Specify location number or describe what you’re looking for"
    }
  }), _vm._v(" "), _c('label', [_vm._v("Do you have insurance?")]), _vm._v(" "), _c('div', {
    staticClass: "radios"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "insurance",
      "value": "Yes",
      "id": "insuranceyes"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "insuranceyes"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "radio",
      "name": "insurance",
      "value": "No",
      "id": "insuranceno"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "insuranceno"
    }
  }, [_vm._v("No")])]), _vm._v(" "), _c('label', [_vm._v("Have you worked with us before?")]), _vm._v(" "), _c('div', {
    staticClass: "radios"
  }, [_c('input', {
    attrs: {
      "type": "radio",
      "name": "workedbefore",
      "value": "Yes",
      "id": "workedbefore"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "workedbefor"
    }
  }, [_vm._v("Yes")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "radio",
      "name": "workedbefore",
      "value": "No",
      "id": "workedbeforeno"
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "workedbeforeno"
    }
  }, [_vm._v("No")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-left"
  }, [_c('label', {
    attrs: {
      "for": "firstname"
    }
  }, [_vm._v("First Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "firstname",
      "placeholder": "First Name",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "lastname"
    }
  }, [_vm._v("Last Name")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "lastname",
      "placeholder": "Last Name",
      "required": ""
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "form-right"
  }, [_c('label', {
    attrs: {
      "for": "email"
    }
  }, [_vm._v("Email Address")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "email",
      "name": "email",
      "placeholder": "Email",
      "required": ""
    }
  }), _vm._v(" "), _c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v("Phone Number")]), _vm._v(" "), _c('input', {
    attrs: {
      "type": "text",
      "name": "phone",
      "placeholder": "Phone"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4c222280","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ContactPage.vue
// module id = 191
// module chunks = 1